module.exports = __webpack_public_path__ + "static/img/17041B_1_2_3_C_20211023_LC.9d5fbd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/17041B_1_2_3_C_20211023_LC.png
// module id = Ww6E
// module chunks = 0